export default "__VITE_ASSET__DqD9fGQn__"